// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"47":"client","328":"admin","818":"auth"}[chunkId] + "." + {"47":"496d0f91","328":"134d4e75","818":"01281af1"}[chunkId] + ".css";
};